import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const heartHealthTestimonialsGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#DCCFBB',
    id: 'rose-1',
    position: [80, 30],
    opacity: 0.8,
    size: 20,
    className: 'rotate-45 hidden lg:block',
  },
];

export default heartHealthTestimonialsGradients;
